import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Switch, Upload } from 'antd';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import documentGalleryService from '../../../services/document-gallery-service';
import { fileTYPE_DOCUMENT } from '../../../constants/app-constants';
import { UploadOutlined } from '@ant-design/icons';

const AddEditDocumentDialog = ({ isShow, onCancel, onSaveComplete, editData, currentParent, currentFolder, currentPath }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [file, setFile] = useState(null);
    const [documentShow, setDocumentShow] = useState([]);

    useEffect(() => {
        if (!isShow) {
            setFile(null);
            setDocumentShow(null);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                shortDescription: editData.shortDescription,
                enable: editData.enable
            });
            setDocumentShow(editData?.fileName);
        } else {
            form.setFieldsValue({
                shortDescription: null,
                enable: true
            });
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            let path = "/"
            const values = await form.validateFields();
            console.log(' values ', values);
            const formData = new FormData();
            if (currentParent === "root") {
                formData.append("parent", currentParent);
                formData.append("path", "");
            } else {
                formData.append("parent", currentParent);
                currentPath.forEach((res) => {
                    path = path + res + "/";
                });

                formData.append("path", path);
            }
            formData.append("enable", values.enable);
            formData.append("shortDescription", values.shortDescription);
            formData.append("file", file);
            
            try {
                dispatch(appLoaderAction.enable());
                if(!editData){
                    await documentGalleryService.add(formData);
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    formData.append("id", bean.id);
                    await documentGalleryService.edit(formData);
                }
                dispatch(appLoaderAction.disale());
                onSaveComplete();
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
            }  catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
			}
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    }

    const handleUpload = (file)=>{
        setFile(file);
        setDocumentShow(
            file.name
        );
        return false;
    }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขเอกสาร' : 'เพิ่มเอกสาร'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />{editData ? 'บันทึก' : 'เพิ่มเอกสาร'}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            <Icon.X className="me-2" size={17} />ยกเลิก
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}
                        validateMessages={{
                            required: 'โปรดระบุ',
                        }}>

                        <Form.Item 
                            key="image"
                            label="เอกสาร" 
                            name="image"
                        >
                            <div>
                                {
                                    editData ? (
                                        <Upload
                                            showUploadList={false}
                                            beforeUpload={handleUpload}
                                            accept={fileTYPE_DOCUMENT}
                                        >
                                            <Button type="dashed" icon={<UploadOutlined />}>
                                                Click for edit
                                            </Button>
                                        </Upload>
                                    ) : (
                                        <Upload
                                            showUploadList={false}
                                            beforeUpload={handleUpload}
                                            accept={fileTYPE_DOCUMENT}
                                        >
                                            <Button type="dashed" icon={<UploadOutlined />}>
                                                Click for Upload
                                            </Button>
                                        </Upload>
                                    )
                                }
                                {documentShow ? 
                                        <div>
                                            <a download>{documentShow}</a> 
                                        </div> : null}
                                {/* {editData ? (
                                        documentShow ? 
                                            <div>
                                                <a download>{documentShow.fileName}</a> 
                                            </div>
                                            : 
                                            null
                                    ) : (
                                        documentShow ? 
                                        <div>
                                            <a download>{documentShow}</a> 
                                        </div>
                                        : 
                                        null
                                )} */}
                            </div>
                        </Form.Item>

                        <Form.Item
                            key="shortDescription"
                            label="คำอธิบาย"
                            name="shortDescription"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item label="การแสดง" name="enable" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    )
}

export default AddEditDocumentDialog;
